import { render, staticRenderFns } from "./PostFilesCarousel.vue?vue&type=template&id=3eedf39d&scoped=true&"
import script from "./PostFilesCarousel.vue?vue&type=script&lang=js&"
export * from "./PostFilesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./PostFilesCarousel.vue?vue&type=style&index=0&id=3eedf39d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eedf39d",
  null
  
)

export default component.exports